import { isNil } from 'lodash-es';

import { formatDateToISOString } from '../../../core/utils/default-formatters.js';
import { isParseableDate } from './is-date.js';

export const parseDataToDate = (value: unknown) => {
  if (isNil(value)) {
    return '';
  }
  if (typeof value === 'string' && value.trim() === '') {
    return '';
  }
  return isParseableDate(value) ? formatDateToISOString(value) : value;
};
